export default __webpack_public_path__ + "static/media/authentication-success-logo.a2d1f7bb.svg";